import {
    getParentCategoryFromSubCategory,
    isSubCategory,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { RelatedCategoriesCarousel } from '../../components/RelatedCategoriesCarousel';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useSearchContext } from '../../context';
import { useCategorySubCategories } from '../../hooks/queries/aggregations';
import { useLocation } from '../../hooks/queries/location';

export const CategoryBrowseRelatedCategories: React.FunctionComponent = () => {
    const { data: subCategories } = useCategorySubCategories();
    const { data: location } = useLocation();

    //Get current active tag
    const { query } = useSearchContext();
    const tag = query?.tags?.[0] || '';
    const activeTag = CATEGORY_CONTENT_MAP[tag];

    //Check if current active tag is a subcat
    const isActiveSubCategory = isSubCategory(tag);
    const parentTagKey = isActiveSubCategory
        ? getParentCategoryFromSubCategory(tag || '')
        : '';
    const parentTag = CATEGORY_CONTENT_MAP[parentTagKey];

    if (!location || !subCategories) return null;

    const activeTagDisplayName = isActiveSubCategory
        ? parentTag.title
        : activeTag?.title;

    const filteredSubCategories = isActiveSubCategory
        ? subCategories.filter((tag) => tag?.key !== activeTag?.key)
        : subCategories;

    if (!filteredSubCategories.length) {
        return null;
    }

    return (
        <CategoryBrowseBucket>
            <RelatedCategoriesCarousel
                headerTitle={gettext(
                    "Explore what's popular within %(activeTagDisplayName)s",
                    {
                        activeTagDisplayName,
                    },
                )}
                location={location}
                useSideNavigation={filteredSubCategories.length > 9}
                filteredSubCategories={filteredSubCategories}
                query={query}
                activeTag={activeTag}
                slidesVisible={{ desktop: 9, tablet: 6 }}
            />
        </CategoryBrowseBucket>
    );
};
